import clsx from 'clsx';
import { useCallback, useState } from 'react';

import { Button } from '~components/generic/editor/Button/Button';
import { DeleteIcon, UserIcon } from '~components/icons';
import { useRemoveUserFromUsergroup } from '~services/api/hooks/user-management.hooks';
import styles from './UsergroupsList.module.css';

export type UsersListItemProps = { groupName: string; user: string };

export const UsersListItem = ({ user, groupName }: UsersListItemProps) => {
  const [isProcessing, setIsProcessing] = useState(false);
  const [isDeleted, setIsDeleted] = useState(false);

  // Define: patch usergroup remove user query
  const { mutate: patchUsergroupRemoveUser } = useRemoveUserFromUsergroup({
    onSuccess: () => {
      setIsDeleted(true);
    },
    onError: () => {
      setIsProcessing(false);
    },
  });

  // Handler: delete user
  const handleOnDelete = useCallback(() => {
    setIsProcessing(true);
    void patchUsergroupRemoveUser({ groupName, userName: user });
  }, [groupName, patchUsergroupRemoveUser, user]);

  return (
    <div className={clsx(styles.listItem, isDeleted && styles.listItemDeleted)}>
      <div className={styles.cellName}>
        <span className={styles.cellNameIcon}>
          <UserIcon />
        </span>
        <span className={styles.cellNameLabel}>{user}</span>
      </div>
      <div className={styles.cellAction}>
        <Button
          onClick={handleOnDelete}
          unflashy
          icon={<DeleteIcon />}
          processing={isProcessing}
          disabled={isDeleted}
        />
      </div>
    </div>
  );
};
